/**
 * Store-safe mode: the iPhone (and Appflow store) build hides everything
 * Apple reads as real-money gambling: crypto purchases, "deposit" wording,
 * card-processor badges, and the free-play slot games. The website is
 * unchanged. REACT_APP_STORE_SAFE=true at build time removes the slot pages
 * from the bundle entirely; the runtime check covers everything else.
 */
import { Capacitor } from '@capacitor/core';

export const IS_STORE_BUILD = process.env.REACT_APP_STORE_SAFE === 'true';

/**
 * Slot games in the store build. App Review rejected the iPhone build four
 * times under 2.3.1(a) over the slot games (Sept-Oct 2026), so the store
 * build ships none of them: no routes, no nav entries, no tutorial chapter,
 * no slot wins in the activity feed, and (via scripts/strip-store-assets.js)
 * no slot sound files or page chunks in the .ipa. The website keeps them.
 * To ship slots on iPhone again, flip this to false AND the inline
 * process.env test above the lazy slot imports in App.tsx.
 */
export const HIDE_SLOTS_IN_STORE = true;
export const hideSlots = (): boolean => HIDE_SLOTS_IN_STORE && isStoreSafe();

export const isStoreSafe = (): boolean => {
  if (IS_STORE_BUILD) return true;
  try { return Capacitor.getPlatform() === 'ios'; } catch { return false; }
};
